// STUDIO183 landing page — restrained scroll-reveal only. No parallax, no autoplay carousels.
(function () {
  function revealImmediately(root) {
    root.querySelectorAll('.s183-reveal:not([data-s183-observed])').forEach(function (el) {
      el.setAttribute('data-s183-observed', '');
      el.classList.add('is-visible');
    });
  }

  function observe(root) {
    var targets = root.querySelectorAll('.s183-reveal:not([data-s183-observed])');
    if (!targets.length) return;

    // Inside the theme editor, sections are swapped via AJAX on every setting
    // change rather than a full page load — skip the animation and show
    // content immediately so edits are never hidden behind a stale observer.
    var inEditor = window.Shopify && window.Shopify.designMode;

    if (inEditor || !('IntersectionObserver' in window)) {
      revealImmediately(root);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) {
      el.setAttribute('data-s183-observed', '');
      observer.observe(el);
    });
  }

  function initEventFilters(root) {
    root.querySelectorAll('[data-s183-events-filters]:not([data-s183-filters-bound])').forEach(function (bar) {
      bar.setAttribute('data-s183-filters-bound', '');
      var grid = bar.parentElement && bar.parentElement.querySelector('[data-s183-events-grid]');
      if (!grid) return;

      bar.addEventListener('click', function (evt) {
        var button = evt.target.closest('.s183-events-filter');
        if (!button) return;

        bar.querySelectorAll('.s183-events-filter').forEach(function (btn) {
          btn.classList.remove('is-active');
        });
        button.classList.add('is-active');

        var filter = button.getAttribute('data-filter');
        grid.querySelectorAll('[data-s183-event]').forEach(function (item) {
          if (filter === 'all') {
            item.hidden = false;
            return;
          }
          var tags = (item.getAttribute('data-tags') || '').split(' ');
          item.hidden = tags.indexOf(filter) === -1;
        });
      });
    });
  }

  function init() {
    observe(document);
    initEventFilters(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan whenever the theme editor swaps a section's HTML in via AJAX —
  // without this, edited sections stay invisible until a full page Save/reload.
  document.addEventListener('shopify:section:load', function (evt) {
    observe(evt.target || document);
    initEventFilters(evt.target || document);
  });
  document.addEventListener('shopify:block:select', function () {
    observe(document);
  });
})();
